class Carousel {

    constructor(element) {
        /**
         * @type {undefined}
         */
        this.carousel = undefined;
        /**
         * @type {NodeListOf<SVGElementTagNameMap[[string]]> | NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element>}
         */
        this.element = element;
        /**
         * @type {NodeListOf<SVGElementTagNameMap[[string]]> | NodeListOf<HTMLElementTagNameMap[[string]]> | NodeListOf<Element>}
         */
        this.items = this.element.querySelectorAll('.list-carousel li');
        /**
         * @type {{container: Element | any, init: number, paused: boolean, onChange: (function(*=, *=): void), prop: string}}
         */
        this.config = {
            container: this.element.querySelector('.list-carousel'),
            prop: 'top',
            paused: true,
            init: -300,
            onChange: (prevIndex, nextIndex) => this.onChange(prevIndex, nextIndex),
            onChangeEnd: () => this.onChangeEnd()
        };
        /**
         * @type {boolean}
         */
        this.isNext = true;
        /**
         * @type {number}
         */
        this.currentIndex = 0;
        /**
         * Init
         */
        this._init();
    }

    /**
     *  Init carousel
     * @private
     */
    _init() {
        Helper.loadScript('/theme/cnosf/asset/vendor/js/simpleslider.min.js').then(() => this._onReady());
    }

    /**
     * On ready carousel
     */
    _onReady() {
        // Set instance simple slider
        this.carousel = simpleslider.getSlider(this.config);
        this._setHeightList();
        this._addListeners();
        this._createCounter();
        this._bindData();
    }

    /**
     * Set height list
     * @private
     */
    _setHeightList() {
        const LIST_ITEM        = this.config.container.querySelectorAll('li');
        const LIST_ITEM_HEIGHT = [];

        for (let i = 0; i < LIST_ITEM.length; i++) {
            LIST_ITEM_HEIGHT.push(LIST_ITEM[i].scrollHeight);
        }

        // Set height & display list container
        this.config.container.style.height  = Math.max(...LIST_ITEM_HEIGHT) + 'px';
        this.config.container.style.opacity = 1;
    }

    /**
     * Add listen carousel
     * @private
     */
    _addListeners() {
        this.element.querySelector('.button-carousel-prev').addEventListener('click', () => this.prev());
        this.element.querySelector('.button-carousel-next').addEventListener('click', () => this.next());
    }

    /**
     * Bind link
     * @private
     */
    _bindData() {
        const index = this.items[this.currentIndex].getAttribute('data-carousel-index-output');
        const href  = this.items[this.currentIndex].getAttribute('data-carousel-link-output');

        // Bind index
        if (index) {
            const inputIndex = this.element.querySelectorAll('[data-carousel-index-input]');

            for (let i = 0; i < inputIndex.length; i++) {
                inputIndex[i].setAttribute('data-carousel-index-input', index);
                inputIndex[i].innerHTML = ((index <= 9) ? '0' : '') + (index);
            }
        }

        // Bind href
        if (href) {
            const inputHref = this.element.querySelectorAll('a[data-carousel-link-input]');
            for (let i = 0; i < inputHref.length; i++) {
                inputHref[i].href = href;
            }
        }
    }

    /**
     * Create counter legend
     * @private
     */
    _createCounter() {
        const dots = this.element.getElementsByClassName('dots-carousel')[0];

        // Add total slide number
        this.element.getElementsByClassName('total-slide')[0].innerHTML = ((this.items.length <= 9) ? '0' : '') + this.items.length;

        // Each list item
        for (let i = 0; i < this.items.length; i++) {
            // Create big counter
            const mediumNumber = this.items[i].querySelector('.medium-number');

            if (mediumNumber) {
                mediumNumber.innerText = ((i <= 8) ? '0' : '') + (i + 1);
            }

            if (dots) {
                // Creat dots
                const listItem = document.createElement('li');
                if (i === 0) {
                    listItem.className = 'active'
                }
                dots.appendChild(listItem)
            }
        }
    }

    /**
     * On change slide
     * @param prevIndex
     * @param nextIndex
     */
    onChange(prevIndex, nextIndex) {
        if (this.isNext) {
            if (this.currentIndex < this.items.length - 1) {
                this.currentIndex++;
            } else {
                this.currentIndex = 0
            }
        } else {
            if (this.currentIndex === 0) {
                this.currentIndex = this.items.length - 1
            } else {
                this.currentIndex--;
            }
        }

        // Remove last dot active and active current
        const dots = this.element.querySelectorAll('.dots-carousel li');

        if (dots.length > 0) {
            for (let i = 0; i < dots.length; i++) {
                dots[i].classList.remove('active')
            }
            dots[this.currentIndex].classList.add('active');
        }


        // Bind link
        this._bindData();

        // lottie animation
        const LOTTIE = this.items[this.currentIndex].querySelector('.lottie');

        if (LOTTIE) {
            // if current item already lottie item
            if (LOTTIE.childElementCount > 0) {
                // Remove all child element
                while (LOTTIE.firstChild) {
                    LOTTIE.removeChild(LOTTIE.firstChild);
                }
            }

            Lottie.runAnimation(LOTTIE);
        }
    }

    /**
     * On change end
     */
    onChangeEnd() {
        for (let i = 0; i < this.items.length; i++) {
            if (i !== this.currentIndex) {
                const LOTTIE_CONTAINER = this.items[i].querySelector('.lottie');
                if (LOTTIE_CONTAINER) {
                    // Remove all child element
                    while (LOTTIE_CONTAINER.firstChild) {
                        LOTTIE_CONTAINER.removeChild(LOTTIE_CONTAINER.firstChild);
                    }
                }
            }
        }
    }

    /**
     * Next slide
     */
    prev() {
        if (this.isNext) {
            this.carousel.reverse();
            this.isNext = false;
        }
        this.carousel.next();
    }

    /**
     * Prev slide
     */
    next() {
        if (!this.isNext) {
            this.carousel.reverse();
            this.isNext = true;
        }
        this.carousel.next();
    }
}